<template>
  <div class="quota-list-container">
    <TagsCloud ref="cloudtage" @cloudTages="cloudTages" />
    <div class="project-table">
      <avue-crud
        :option="tableConfig"
        :data="tableData"
        v-model="searchForm"
        :page.sync="page"
        :search.sync="searchForm"
        @search-reset="searchReset"
        @on-load="queryTableData"
        @search-change="searchChange"
        @sort-change="sortChange"
        @refresh-change="queryTableData"
        @selection-change="selectionChange"
        @row-click="goDetail"
      >
        <template slot="searchMenu" slot-scope="{ row }">
          <el-button type="primary" @click="save(row)">保存</el-button>
          <!-- <el-button type="primary"  @click="openFilter">
                        <a-icon type="filter" /> 高级筛选
                    </el-button> -->
        </template>
        <template slot="investStr" slot-scope="{ row }">
          第{{ row.investBatch }}批/第{{ row.paymentBatch }}笔
        </template>
        <template slot="projectName" slot-scope="{ row }">
          <div class="project-name">{{ row.projectName }} / {{row.contractName}}</div>
        </template>
        <template slot="menuLeft">
          <el-button
            size="small"
            type="primary"
            @click="handleAdd()"
            v-if="permission.paymentPlanAdjustList_add"
          >
            新增付款
          </el-button>

          <el-button
            size="small"
            :disabled="
              writeoffDisabled || disabled || selectionList.length != 1
            "
            type="primary"
            plain
            v-if="permission.paymentPlanAdjustList_edit"
            @click="handleEdit()"
          >
            编辑
          </el-button>
          <el-button
            size="small"
            :disabled="disabled"
            type="danger"
            plain
            v-if="permission.paymentPlanAdjustList_delete"
            @click="handleDelete()"
          >
            删除
          </el-button>
          <!-- <el-button
            :disabled="writeoffDisabled"
            size="small"
            type="primary"
            @click="handleCancel()"
            v-if="permission.factoring_writeoff"
          >
            核销
          </el-button> -->
        </template>

        <template slot="investBatch" slot-scope="{ row }">
          <div class="project-name" @click="goDetail(row)">
            {{ row.investBatch ? `第${row.investBatch}批` : row.investBatch }}
          </div>
        </template>
      </avue-crud>
    </div>
    <el-dialog
      :close-on-click-modal="false" title="新增付款" destroy-on-close :visible.sync="dialogVisible" width="40%">
      <div class="addForm">
        <avue-form
          ref="basicInfo"
          v-model="addFormData"
          :option="addFormConfig"
        >
          <template #name>
            <!-- 存在绑定ID时不可更改项目 -->
            <SelectInput
              :clearable="false"
              bindLabel="investName"
              bindKey="id"
              dataUrl="/bl/blinvest/page"
              methods="get"
              dataMethod="params"
              searchKey="projectName"
              :initParam="{
                auditStatus: 2,
              }"
              :innerKey="[
                {
                  value: 'investName',

                },
                {
                  value: 'contractManage',
                  valueInner: 'contractName',
                },
              ]"
              :bindId="addFormData.id ? addFormData.id : ''"
              @handleChange="setProjectInfo"
            />
          </template>
        </avue-form>
      </div>
    </el-dialog>

    <el-dialog
      :close-on-click-modal="false"
      title="核销"
      :visible.sync="addLendingVisble"
      :modal-append-to-body="false"
      width="70%"
      class="addLending_dialog"
    >
      <template>
        <!-- 核销 -->
        <div class="detail-one">
          <div class="detail-top">
            <div class="detail-title">相关信息</div>
          </div>
          <div class="detail-content">
            <CommonDetail
              :configArray="detailConfig['column']"
              :initValue="detailData"
            />
          </div>
        </div>

        <div class="detail-one">
          <div class="detail-top">
            <div class="detail-title">请填写本次核销信息</div>
          </div>
          <div class="detail-content">
            <avue-form
              ref="lendingInfo"
              v-model="detailData"
              :option="writeOffFormConfig"
            >
              <template #investTitle>
                <div class="slot-content">
                  {{ detailData.projectName }}/{{ detailData.investBatch }}
                </div>
              </template>
              <template #moneyTypeStr>
                <div class="slot-content">{{ detailData.moneyTypeStr }}</div>
              </template>
              <template #shouldPay>
                <div class="slot-content">
                  <div class="content-line">
                    {{ detailData.investShouldMoneyStr }}
                    <span
                      class="show-detail"
                      @click="showDetails = showDetails ? false : true"
                      >{{ showDetails ? "[收起]" : "[本笔付款详情]" }}</span
                    >
                  </div>
                  <div class="detail-block" v-if="showDetails">
                    <div class="detail-inner">
                      <div class="info-one">
                        <div class="info-title green-point">本笔付款金额：</div>
                        <div class="info-content">
                          {{ detailData.investMoney }}
                        </div>
                      </div>
                      <!-- 资金投放 -->
                      <div class="info-one" v-if="detailData.moneyType == 0">
                        <div class="info-title green-point">内扣明细：</div>
                        <div class="info-content"></div>
                      </div>
                      <template v-if="detailData.moneyType == 0">
                        <!-- <template  > -->
                        <div
                          class="info-one"
                          :key="index"
                          v-for="(item, index) in detailData.innerList"
                        >
                          <div class="info-title">
                            {{ item.outlayTypeStr }}：
                          </div>
                          <div class="info-content">
                            {{ getMoney(Number(item.outlayAmount)) }}元
                          </div>
                        </div>
                        <!-- </template> -->
                      </template>
                      <div class="info-one" v-if="detailData.moneyType == 0">
                        <div class="info-title">合计：</div>
                        <div class="info-content">
                          {{ detailData.totalCost }}
                        </div>
                      </div>

                      <!-- 保证金归还 -->
                      <div class="info-one" v-if="detailData.moneyType == 1">
                        <div class="info-title green-point">保证金明细：</div>
                        <div class="info-content"></div>
                      </div>
                      <template v-if="detailData.moneyType == 1">
                        <!-- <template  > -->
                        <div
                          class="info-one"
                          :key="index"
                          v-for="(item, index) in marginList"
                        >
                          <div class="info-title">保证金：</div>
                          <div class="info-content">
                            {{ getMoney(Number(item.refundedAmount)) }}元
                          </div>
                        </div>
                        <!-- </template> -->
                      </template>

                      <div class="info-one" v-if="detailData.moneyType == 1">
                        <div class="info-title">合计：</div>
                        <div class="info-content">
                          {{ detailData.investMoney }}
                        </div>
                      </div>
                      <div class="info-one">
                        <div class="info-title green-point">
                          本笔应实付金额：
                        </div>
                        <div class="info-content">
                          {{ detailData.investShouldMoneyStr }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
              <template #planPayDate>
                <div class="slot-content">{{ detailData.planPayDate }}</div>
              </template>
              <template #bankInfo>
                <div class="slot-content">{{ detailData.accountName }}</div>
              </template>
            </avue-form>

            <div class="detail-content stone-con">
              <template v-for="(item, index) in paymentList">
                <div class="stone-one" :key="index">
                  <div class="form-con">
                    <avue-form
                      ref="paymentInfo"
                      v-model="paymentList[index]"
                      :option="paymentListConfig"
                    >
                      <template #payBankId>
                        <CommonSelect
                          bindLabel="bankOpenName"
                          bindKey="id"
                          bindValue="bankOpenName"
                          methods="get"
                          dataMethod="params"
                          :initParam="initParam"
                          dataUrl="bl/custbankbl/page"
                          @handleChange="
                            (data) => {
                              setBankInfo(data, index);
                            }
                          "
                        />
                      </template>
                    </avue-form>
                  </div>
                  <!-- <el-divider direction="vertical" v-if="paymentList.length > 1"></el-divider> -->
                  <div class="delete-con" v-if="paymentList.length > 1">
                    <i
                      class="el-icon-delete-solid"
                      @click="deletePayment(item, index)"
                    ></i>
                  </div>
                </div>
              </template>

              <div class="add-btn">
                <el-button size="small" icon="el-icon-plus" @click="addPayment"
                  >添加支付</el-button
                >
              </div>
            </div>

            <div class="submit-con">
              <el-button type="primary" size="mini" @click="validWriteOffForm()"
                >核销</el-button
              >
              <el-button
                type="primary"
                size="mini"
                plain
                @click="addLendingVisble = false"
                >取消</el-button
              >
            </div>
          </div>
        </div>
      </template>
    </el-dialog>
    <SelectPerson
      ref="selectperson"
      :checkUserList="checkUserList"
      :isOnly="true"
      :clear="false"
      @setPeople="setPeople"
    />

    <SelectDepartment
      ref="selectdepartment"
      :checkdepartment="checkdepartment"
      :isOnly="true"
      @setDepartment="setDepartment"
    />

    <ExportData ref="exportData" @exportDownload="exportDownload" />
  </div>
</template>
<script>
import TagsCloud from "@/components/TagsCloud/TagsCloud";
import ExportData from "@/components/exportData/exportData";
import SelectPerson from "@/components/SelectPersonnel/person";
import SelectDepartment from "@/components/SelectDepartment/department";
import util from "@/mixins/util";
import {
  paymentPlanAdjustConfig,
  detailConfig,
  writeOffFormConfig,
} from "./config.js";
import Frame from "@/components/frame/frame";
import CommonDetail from "@/components/commonDetail/commonDetail";
import * as api from "@/api/factoring/factoring";
import CommonSelect from "@/components/commonSelect/commonSelect";
import SelectInput from "./components/selectInput";
import { downLoadTemplateGet } from "@/router/downLoadTem";
import { mapGetters } from "vuex";
import workFlow from '@/mixins/workFlow'
import { floatAdd } from "@/util/util";
import moment from "moment";
export default {
  name: "earnoutList",
  mixins: [workFlow,util],
  data() {
    return {
      drawer: false,
      dialogVisible: false,
      tableData: [],
      searchForm: {},
      checkUserList: [],
      checkdepartment: [],
      tableConfig: paymentPlanAdjustConfig(
        this.getMoney,
        this.dateConvert,
        this.selectPersonClick,
        this.selectDeptClick
      ),
      page: {
        currentPage: 1,
        total: 0,
        layout: "total,pager,prev, next",
        background: false,
        pageSize: 10,
      },
      bondVisible: true,
      detail: {},
      selectionList: [],
      disabled: true,
      writeoffDisabled: true,
      addFormData: {},
      addFormConfig: {
        labelWidth: 130,
        emptyBtn: false,
        submitBtn: false,
        column: [
          {
            label: "投放名称",
            prop: "name",
            formslot: true,
            disabled: false,
            span: 20,
            placeholder: "请选择",
          },
        ],
      },
      addLendingVisble: false,
      // 应付款详情
      detailData: {},
      detailConfig: detailConfig(),
      writeOffFormConfig: writeOffFormConfig(),
      initParam: { isBusiness: 1 },
      paymentListConfig: {
        labelWidth: 240,
        backgroundColor: "#f7f9fe",
        align: "center",
        submitBtn: false,
        emptyBtn: false,
        menuBtn: false,
        menu: false,
        column: [
          {
            label: "付款帐号",
            prop: "payBankId",
            formslot: true,
            span: 24,
            rules: [
              {
                required: true,
                message: "请选择付款帐号",
              },
            ],
          },
          {
            label: "付款金额",
            type: "input",
            prop: "payMoney",
            span: 24,
            append: "元",
            rules: [
              {
                required: true,
                message: "请输付款金额",
              },
            ],
          },
          {
            label: "付款日期",
            type: "date",
            prop: "payDate",
            format: "yyyy-MM-dd",
            valueFormat: "yyyy-MM-dd",
            span: 24,
            rules: [
              {
                required: true,
                message: "请选择付款日期",
              },
            ],
          },
        ],
      },
      paymentList: [
        {
          payBankId: "",
          payMoney: "",
          payDate: "",
          paymentId: "",
        },
      ],

      // 保证金数据
      marginList: [],
      multipleSelection: [],
      showDetails: false,
    };
  },
  components: {
    TagsCloud,
    SelectPerson,
    SelectDepartment,
    ExportData,
    Frame,
    CommonDetail,
    CommonSelect,
    SelectInput
  },
  computed: {
    ...mapGetters(["userInfo", "permission"]),
  },
  watch: {
    selectionList: {
      handler(data) {
        let writeoffList = data.filter((item) => {
          return item.isWriteoff == 0; //0 ? "未核销" : "已核销"
        });
        let list = data.filter((item) => {
          return item.createUser == this.userInfo.user_id;
        });
        //只能选一个，  核销按钮
        this.writeoffDisabled =
          writeoffList.length != data.length || data.length != 1;

        // 编辑和删除权限
        this.disabled = list.length != data.length || data.length == 0;
      },
      deep: true,
    },
  },
  methods: {
    setBankInfo(data, index) {
      this.paymentList[index].payBankId = data.id;
    },
    addPayment() {
      let obj = {
        payBankId: "",
        payMoney: "",
        payDate: "",
        paymentId: "",
      };
      this.paymentList.push(obj);
    },
    deletePayment(data, index) {
      let self = this;
      this.$confirm("确定删除该条支付信息?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let newArray = [];
        newArray = newArray.concat(
          JSON.parse(JSON.stringify(self.paymentList))
        );
        newArray.splice(index, 1);
        self.paymentList = newArray;
      });
    },
    async validWriteOffForm() {
      // 校验付款信息
      let valid = true;
      let self = this;
      this.paymentList.map((item, index) => {
        if (item.payBankId == "" || item.payMoney == "" || item.payDate == "") {
          valid = false;
          self.$message({
            type: "warning",
            message: `请先补全第${index + 1}条付款信息`,
          });
        } else {
          item.paymentId = self.selectionList[0].id;
        }
      });
      if (valid) {
        // 核销
        let params = {
          id: self.selectionList[0].id,
          custId: this.detailData.sellerCustId,
          paymentDetails: this.paymentList,
          investId: this.detailData.investId,
        };
        let res = await api.cancelLending(params);
        if (res.data.code == 200) {
          this.addLendingVisble = false;
          this.queryTableData();
          this.$message({
            type: "success",
            message: "核销成功",
          });
        }
      }
    },

    cloudTages(data) {
      this.searchForm = data;
    },
    goDetail(row) {
       if(!this.permission.paymentPlanAdjustList_view){
        this.$message.error("没有查看权限");
        return
      }
      this.$router.push({
        path: `/factoring/paymentPlanAdjustManage/paymentPlanAdjustDetail/${row.id}`,
      });
    },

    async queryTableData() {
      let params = {
        current: this.page.currentPage,
        size: this.page.pageSize,
        ...this.searchForm,
        createDateBegin: this.searchForm.timePic&&this.searchForm.timePic.length>0
          ? moment(this.searchForm.timePic[0]).format("YYYY-MM-DD")
          : undefined,
        createDateEnd: this.searchForm.timePic&&this.searchForm.timePic.length>0
          ? moment(this.searchForm.timePic[1]).format("YYYY-MM-DD")
          : undefined,
      };
      let res = await api.getLendingList(params);
      if (res.data.code == 200) {
        this.tableData = res.data.data.records;
        this.page.total = res.data.data.total;
      } else {
        this.$message.error(res.data.msg);
      }
    },

    //选择项发生变化 传入数组
    selectionChange(list) {
      this.selectionList = list;
    },

    //核销
    async handleCancel() {
      if (this.permission.factoring_writeoff) {
        if (this.selectionList[0].isWriteoff == 0) {
          let res = await api.lendingDetail({ id: this.selectionList[0].id });
          this.addLendingVisble = true;
          this.dealDetailData(res.data.data);
        } else {
          this.$message.error("该条数据已核销");
        }
      } else {
        this.$message.warning("您暂无权限进行付款核销");
      }
    },
    async dealDetailData(detailData) {
      let totalCost = 0;
      detailData.innerCost = 0;
      detailData.innerList.map((i) => {
        totalCost =floatAdd(totalCost,Number(i.innerMoney)) ;
      });
      if (detailData.paymentDetailList.length > 0) {
        detailData.paymentDetailList.map((item) => {
          if (JSON.stringify(item.custBankBl) != "{}") {
            item.paymentAccountStr = `${item.custBankBl.bankAccountName} ${item.custBankBl.bankOpenName} ${item.custBankBl.bankNo}`;
          } else {
            item.paymentAccountStr = "暂无银行信息";
          }
        });
      }
      detailData.innerList.map((i) => {
        detailData.innerCost =floatAdd(detailData.innerCost,Number(i.innerMoney)) ;
      });

      this.detailData = {
        ...detailData,
        paymentBatch: detailData.paymentBatch,
        innerCost: detailData.innerCost,

        // sellerCustName: this.investData.contractManage.sellerCustName,
        // sellerCustId: this.investData.contractManage.sellerCustId,
        accountingEntity: detailData.formAccountingEntityStr,
        // contractName: this.investData.contractManage.name?this.investData.contractManage.name: '',
        investBatch: `第${detailData.investBatch}批`,
        planPayDate: detailData.planPayDate,
        investMoney: `${this.getMoney(Number(detailData.investMoney))}元`,
        moneyType: detailData.moneyType,
        moneyTypeStr: detailData.moneyType == 1 ? "保证金退还" : "资金投放",
        accountName: `${detailData.custBankBl.bankAccountName} ${detailData.custBankBl.bankOpenName} ${detailData.custBankBl.bankNo}`,
        moneyTitle: `${detailData.projectName}/第${detailData.investBatch}批`,
        writeOff: detailData.isWriteoff,
        innerList: detailData.innerList,
        investAllMoney: `${this.getMoney(Number(detailData.investAllMoney))}元`,
        totalCost: `${this.getMoney(totalCost)}元`,
        investShouldMoneyStr: `${this.getMoney(
          detailData.investShouldMoney
        )}元`,
        investShouldMoney: detailData.investShouldMoney,
        paymentDetailList: detailData.paymentDetailList,
        writeoffUserName: detailData.writeoffUserName,
        writeoffTime: detailData.writeoffTime,
        contractName: detailData.contractName,
      };
    },

    setProjectInfo(data) {
      this.dialogVisible = false;
      window.sessionStorage.setItem(
        "investmentLoanProjectInfo",
        JSON.stringify(data)
      );

      // 跳转到详情
      this.$router.push({
        path: "/factoring/paymentPlanAdjustManage/paymentPlanAdjustAdd/0",
        // query: {
        //     projectData: JSON.stringify(data)
        // }
      });
    },

    handleAdd() {
      this.dialogVisible = true;
    },

    handleEdit() {
      let data = this.selectionList[0];

      this.$router.push({
        path: `/factoring/paymentPlanAdjustManage/paymentPlanAdjustEdit/${data.id}`,
      });
    },

    //批量删除
    async handleDelete() {
      let self = this;
      let startDelete = () => {
        self
          .$confirm("确定删除选择的数据?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
          .then(() => {
            self.deleteData();
          })
          .catch(() => {
            self.$message({
              type: "info",
              message: "已取消删除",
            });
          });
      };

      let data = this.selectionList[0];
      if (data.flowableId != "" && data.auditStatus == 1) {
        // 获取流程数据
        await this.queryFlowData(data.flowableId);
        let presentFlow = this.flowData[this.flowData.length - 1];
        if (
          this.processDetail.flow[2].historyActivityId ==
          presentFlow.historyActivityId
        ) {
          startDelete();
        } else {
          this.$message.error("流程审批中不能删除");
        }
      } else {
        // 直接弹框提示
        startDelete();
      }
    },
    // 删除参数ids 提取this.selectionList中的id用,隔开成字符串
    async deleteData() {
      let ids = this.selectionList.map((item) => {
        return item.id;
      });
      let res = await api.deleteLending({ ids: ids.join(",") });
      if (res.data.code == 200) {
        this.$message.success("删除成功");
        // 刷新列表
        this.queryTableData();
      }
    },
    //清空
    searchReset() {
      let that = this;
      // that.$refs.projectName.resetList();
      that.searchForm = {};
      that.page.currentPage = 1;
      that.queryTableData();
    },
    //搜索
    searchChange(params, done) {
      this.queryTableData();
      done();
    },
    //导出数据
    exportShow() {
      this.$refs.exportData.showModel();
    },

    //下载
    exportDownload(value) {
      let page = this.page;
      let data = {
        export: value.code,
        auditState: 1,
      };
      if (value.code == 1) {
        data = {
          ...data,
          current: page.currentPage,
          size: page.pageSize,
          ...this.searchForm,
        };
      } else if (value.code == 2) {
        data = {
          ...data,
          ...this.searchForm,
        };
      }
      downLoadTemplateGet("", data).finally(() => {
        this.loading = false;
        this.$message({
          type: "success",
          message: "已下载",
        });
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.quota-list-container {
  /deep/.el-table .cell  {
    padding-left: 0px !important;
    padding-right: 0px !important;
  }
  .topcrud {
    line-height: 45px;
    font-size: 18px;
    background: #f9f9f9;
    border-radius: 15px 15px 0 0;
    text-indent: 25px;
    // margin: 0 5px;
    border-bottom: 1px solid #e9e9e9;
    .messagetitle {
      font-weight: bolder;
    }
  }
  .project-table {
    background: #ffff;
    padding: 25px;
  }
  .project-name {
    // overflow: hidden;
    white-space: normal;
    // text-overflow: ellipsis;
    color: #409EFF;
  }
  .project-name:hover {
    color: #409eff;
    cursor: pointer;
  }
  .quota-status {
    position: relative;
    padding-left: 20px;
  }
  .quota-status::before {
    position: absolute;
    content: "";
    background-color: #19b16b;
    width: 8px;
    height: 8px;
    border-radius: 4px;
    left: 12px;
    top: 7px;
  }
  .red-point::before {
    color: #f56c6c !important;
  }
}
.detail-button {
  font-size: 12px;
  color: #19be6b;
  cursor: pointer;
  margin-left: 15px;
}
.show-detail {
  color: #409eff;
  cursor: pointer;
  margin-left: 10px;
}
.detail-block {
  // height: 230px;
  background: inherit;
  background-color: rgba(249, 249, 249, 1);
  border-width: 1px;
  border-style: solid;
  border-color: rgba(233, 233, 233, 1);
  border-radius: 3px;
  .detail-inner {
    width: 100%;
    padding: 20px 30px 20px 50px;
    .info-one {
      display: flex;
      .info-title {
        width: 120px;
        position: relative;
        color: #666666;
        font-size: 12px;
      }
      .green-point::before {
        width: 8px;
        height: 8px;
        border-radius: 4px;
        content: "";
        position: absolute;
        background-color: #51d351;
        top: 13px;
        left: -15px;
      }
      .info-content {
        color: #333;
        font-size: 12px;
      }
    }
  }
}
.detail-one {
  padding: 0px 30px !important;
  .detail-top {
    padding: 20px 5px;
    .detail-title {
      color: #666;
      font-weight: 700;
      font-size: 14px;
      line-height: 28px;
      position: relative;
      .title-tips {
        font-weight: 400;
        color: #666666;
        font-size: 13px;
      }
    }
    .detail-title::before {
      content: "";
      width: 5px;
      background-color: #409eff;
      height: 18px;
      position: absolute;
      left: -12px;
      top: 5px;
    }
  }

  .stone-con {
    width: 88%;
    margin: 0 auto;
    .stone-detail-one {
      background-color: #f7f9fe;
      padding: 10px 10px 10px 10px;
      border: 1px solid #e4e4e4;
      border-radius: 4px;
      margin-bottom: 10px;
      .el-collapse-item__wrap {
        background-color: #f7f9fe !important;
        border: none !important;
      }
      .el-collapse {
        border: none !important;
      }
      .el-form-item {
        margin-top: 14px !important;
        margin-bottom: 14px !important;
      }
    }
    .stone-one {
      display: flex;
      justify-content: space-between;
      align-items: center;
      background-color: #f7f9fe;
      padding: 30px 10px 10px 10px;
      border: 1px solid #e4e4e4;
      border-radius: 4px;
      margin-bottom: 10px;
      .form-con {
        border-right: 1px dashed #e4e4e4;
      }
      .delete-con {
        width: 300px;
        height: 100%;
        text-align: center;
        i {
          font-size: 30px;
          color: #409eff;
        }
      }
      .el-collapse-item__wrap {
        background-color: #f7f9fe !important;
        border: none !important;
      }
      .el-collapse {
        border: none !important;
      }
      .el-form-item {
        margin-top: 14px !important;
        margin-bottom: 14px !important;
      }
    }
    /deep/.el-collapse-item__wrap {
      background-color: #f7f9fe !important;
      border: none !important;
    }
    /deep/.el-collapse {
      border: none !important;
    }
  }

  .add-btn {
    text-align: right;
    margin-top: 10px;
    margin-bottom: 10px;
  }
}
.submit-con {
  text-align: center;
  margin-bottom: 40px;
  button {
    width: 150px;
  }
}
</style>